import axios from 'axios'
import { config } from '../../config'
import { APP_CONSTANTS } from '../../utils/AppConstants'
import API_ENDPOINTS from './endpoints'

export function addSuppliesCategoryAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'post',
        url: `${config.baseUrl}/${API_ENDPOINTS.supplies.category.addCategory}`,
        data: payload,
        headers: {
            'authToken': user.authToken
        }
    })
}

export function suppliesCategoryListAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'get',
        url: `${config.baseUrl}/${API_ENDPOINTS.supplies.category.list}`,
        params: payload,
        headers: {
            'authToken': user.authToken
        }
    })
}

export function updateSuppliesCategoryAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'put',
        url: `${config.baseUrl}/${API_ENDPOINTS.supplies.category.updateDetails}`,
        data: payload,
        headers: {
            'authToken': user.authToken
        }
    })
}

export function addSuppliesItemAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'post',
        url: `${config.baseUrl}/${API_ENDPOINTS.supplies.item.addItem}`,
        data: payload,
        headers: {
            'authToken': user.authToken
        }
    })
}

export function suppliesItemListAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'get',
        url: `${config.baseUrl}/${API_ENDPOINTS.supplies.item.list}`,
        params: payload,
        headers: {
            'authToken': user.authToken
        }
    })
}

export function suppliesItemDetailAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'get',
        url: `${config.baseUrl}/${API_ENDPOINTS.supplies.item.details}/${payload}`,
        headers: {
            'authToken': user.authToken
        }
    })
}

export function consumeSuppliesItemAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'put',
        url: `${config.baseUrl}/${API_ENDPOINTS.supplies.item.consumeItem}`,
        data: payload,
        headers: {
            'authToken': user.authToken
        }
    })
}

export function updateSuppliesItemStockAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'put',
        url: `${config.baseUrl}/${API_ENDPOINTS.supplies.item.updateStock}`,
        data: payload,
        headers: {
            'authToken': user.authToken
        }
    })
}